"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PartDateInput = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var semantic_ui_react_1 = require("semantic-ui-react");
var util_1 = require("../util");
var i18n_1 = __importDefault(require("../i18n"));
var style = { width: "6em" };
var PartDateInput = function (_a) {
    var date = _a.date, setDate = _a.setDate;
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(semantic_ui_react_1.Input, { size: "small", style: style, min: "0", step: "1", value: (0, util_1.displayDeepProp)(date, "year"), onChange: genSetDateProp(date, setDate, "year"), type: "number", placeholder: i18n_1.default.year }), "/", (0, jsx_runtime_1.jsx)(semantic_ui_react_1.Input, { size: "small", style: style, min: "1", max: "12", step: "1", value: (0, util_1.displayDeepProp)(date, "month"), onChange: genSetDateProp(date, setDate, "month"), type: "number", placeholder: i18n_1.default.month }), "/", (0, jsx_runtime_1.jsx)(semantic_ui_react_1.Input, { size: "small", style: style, min: "1", max: "31", step: "1", value: (0, util_1.displayDeepProp)(date, "date"), onChange: genSetDateProp(date, setDate, "date"), type: "number", placeholder: i18n_1.default.date })] }));
};
exports.PartDateInput = PartDateInput;
var genSetDateProp = function (date, setDate, key) { return function (e, _a) {
    var _b;
    var value = _a.value;
    var valueNum = Number(value);
    if (!valueNum) {
        var newDate = __assign({}, date);
        delete newDate[key];
        setDate(newDate);
    }
    else {
        setDate(__assign(__assign({}, date), (_b = {}, _b[key] = valueNum, _b)));
    }
}; };
